import { useState, useEffect, useRef } from "react";
import _ from "lodash";
import { HeaderBack } from '@/components/common/header';
import { VehicleModelVariant, VariantSeriesSale, VehicleReviewAuthor, PopularCarBrands, VehicleOwnershipCost, VehicleOwnershipCostItem } from ".";
import { PlacementBanner } from "../placement";
import { DealerSection } from "../dealer";
import { _numToPrice, _handleOnClickCompare, _getDealerList, _getAllVehicleTopList, _getAllVehicleSeries, _handleOnClickGoCompare, _getAllVehicleVariant, _getAllAuthor } from "../../libraries/common";
import { hasCookie, getCookie } from "cookies-next";
import { useRouter } from "next/router";
import { CompareBottomButton } from "../compare";
import { PhoneCallListModal, VehicleVariantModal } from "../modal";
import Link from "next/link";
import { mobileViewWidth, pageLink } from "../../config/site";
import { useViewportSize } from "@mantine/hooks";
import Redux from "@/action";
import { Footer } from "../common/footer";
import { MyBody } from "../body/body";
import { CustomLink } from "../app/customLink";

export const VehicleVariant = (props) => {
    const { t, fetchedData, query } = props
    const { store, dispatch } = Redux()
    const [loading, setLoading] = useState(true)

    // compare store
    const [compareList, setCompareList] = useState(hasCookie('compare_list') ? JSON.parse(getCookie('compare_list')) : []) 

    // vehicle on sale
    const [vehicleOnSaleList, setVehicleOnSaleList] = useState([])

    // dealer
    const [dealerList, setDealerList] = useState([])
    const [phoneCallOpen, setPhoneCallOpen] = useState(false)
    const [phoneNumberList, setPhoneNumberList] = useState([])

    // top List brand and model
    const [vehicleTopList, setVehicleTopList] = useState({brand: [], model: []})
    const router = useRouter()
    const containerRef = useRef(null)

    // vehicle variant modal
    const [vehicleVariantModalOpen, setVehicleVariantModalOpen] = useState(false)
    const [vehicleVariantData, setVehicleVariantData] = useState({}) // variant list by model

    // author list
    const [authorList, setAuthorList] = useState([]);
    const { width } = useViewportSize()

    useEffect(()=>{
        let isMounted = true; // Flag to track component mount status

        const fetchData = async() =>{
            try{
                setLoading(true)
                setAuthorList([]);
                await _getAllVehicleSeries(setVehicleOnSaleList, {vehicle_model_id: fetchedData?.vehicle_model_id, not_in_variant_id: fetchedData?.variant_id})
                await _getDealerList({vehicleBrandId: fetchedData.vehicle_brand_id, limit: 6, offset: 0}, setDealerList);

                if(store?.path?.dataAllVehicleTopList == undefined){
                    await _getAllVehicleTopList(dispatch);
                }

                await _getAllVehicleVariant(setVehicleVariantData, {vehicle_model_id: fetchedData.vehicle_model_id})
                if(!_.isEmpty(JSON.parse(fetchedData?.reviewer_id)) && !_.isEmpty(fetchedData?.vehicle_model_id)){
                    await _getAllAuthor(setAuthorList, {author_id_list: _.join(JSON.parse(fetchedData?.reviewer_id),','), vehicle_model_id: fetchedData?.vehicle_model_id, limit: 6, offset: 0})
                }
            }catch(error){
                console.log(error)
            }finally{
                if (isMounted) {
                    // Only update state if the component is still mounted
                    setLoading(false);
                }
            }
        }
        
        if(fetchedData){
            fetchData();
            if(window.innerWidth <= mobileViewWidth){
                window.scrollTo({
                    top: 1,
                    behavior: 'instant'
                });
            } else {
                if (containerRef.current) {
                    containerRef.current.scrollTo({
                    top: 0,
                    behavior: 'instant'
                    });
                }
            }
        }

        return () => {
            isMounted = false; // Mark the component as unmounted
        };
    },[fetchedData])  

    const _handleClickVariantItem = (value) => {
        router.push(`${router.query.vehicle[0]}/${router.query.vehicle[1]}/${value.custom_url}`)
        setVehicleVariantModalOpen(false)
    }

    return (
        <>
            <MyBody
                t={t}
                containerRef={containerRef}
                containerStyle={(compareList.length >= 1 && width <= mobileViewWidth) ? {paddingBottom: `6.4rem`} : {}}
                containerClass={"vehicleVariantContainer"}
                headerComponent={
                    <HeaderBack t={t} />
                }
                navigationComponent={
                    compareList.length >= 1 ?
                    <CompareBottomButton compareList={compareList} t={t} handleOnClickGoCompare={(value)=>_handleOnClickGoCompare(value, router)} />
                    :
                    null
                }
                modalComponent={
                    <>
                        <VehicleVariantModal 
                            t={t}
                            vehicleVariantModalOpen={vehicleVariantModalOpen}
                            setVehicleVariantModalOpen={setVehicleVariantModalOpen}
                            handleClickVariantItem={_handleClickVariantItem}
                            vehicleVariantData={vehicleVariantData}
                            vehicleModelActive={{image_path: fetchedData?.model_image_path,brand_name: fetchedData?.brand_name, model_name: fetchedData?.model_name}}
                            isActiveVaraintList={[fetchedData?.variant_id]}
                            loading={loading}
                        />
                        <PhoneCallListModal
                            phoneCallOpen={phoneCallOpen}
                            setPhoneCallOpen={setPhoneCallOpen} 
                            phoneNumberList={phoneNumberList}
                            t={t}
                        />
                    </>
                }
            >
                <VehicleModelVariant t={t} setVehicleVariantModalOpen={setVehicleVariantModalOpen} imagePath={!_.isEmpty(fetchedData?.variant_cover_image_path) ? fetchedData?.variant_cover_image_path : !_.isEmpty(fetchedData?.variant_image_path) ? fetchedData?.variant_image_path : ''} />
                <div className="vehicleVariant_Box">
                    <div className="containerPadding">
                        <p className="fontSize_20 fontWeight_bold">
                            {fetchedData?.name}
                        </p>
                        <p className="fontSize_16 fontWeight_semiBold fontColor_lightBlue vehicleVariant_header_titlePrice">
                            {_numToPrice(fetchedData?.price)}
                        </p>
                        <p className="fontSize_12 fontColor_lightGrey3 vehicleVariant_header_titleMonlthPrice">
                            {`${_numToPrice(fetchedData?.monthly_payment)}/month`}
                        </p>
                    </div>
                    <VehicleOwnershipCost t={t} 
                        title={fetchedData?.name}
                        showHeader={false} 
                        showCompare={true}
                        data={{min_road_tax: fetchedData?.road_tax, min_insurance_cost: fetchedData?.insurance_cost, name: fetchedData?.name, price: fetchedData?.price, capacity: fetchedData?.capacity}}
                        selfVaranitData={fetchedData}
                        isActiveVaraintList={_.compact(_.map(compareList, (value) => value.variant_id))} 
                        handleOnClickCompare={(value, type)=>_handleOnClickCompare(value, type, setCompareList)} 
                    />
                    <div className="vehicleVariantSpec containerPadding">
                        <div className="vehicleVariantSpec_header">
                            <p className="fontSize_16 fontWeight_bold">
                                {fetchedData?.name}
                            </p>
                            <CustomLink href={`${pageLink.compare.compareMidUrl}${fetchedData?.compare_custom_url}?v1=${fetchedData?.variant_id}`}>
                                <div className="vehicleVariantSpec_header_image cursorPointer">
                                    <img 
                                        className="w-100"
                                        src="/assets/images/right_circle_blue_icon.svg"
                                    />
                                </div>
                            </CustomLink>
                        </div>
                        <div className="vehicleVariantSpec_Contant">
                            <VehicleOwnershipCostItem label={t('body_type')} text={fetchedData?.body_type ?? '-'} />
                            <VehicleOwnershipCostItem label={t('segment')} text={fetchedData?.segment ?? '-'} />
                            {
                                fetchedData?.fuel == "EV" ?
                                <VehicleOwnershipCostItem label={t("ev_range")} text={`${fetchedData?.electric_motor_ev_range > 0 ? fetchedData?.electric_motor_ev_range : '-'} km`} />
                                :
                                <VehicleOwnershipCostItem label={t("capacity")} text={`${fetchedData?.capacity > 0 ? fetchedData?.capacity : '-'} L`} />
                            }
                            {/* <VehicleOwnershipCostItem label={t("capacity")} text={`${fetchedData?.capacity > 0 ? fetchedData?.capacity : '-'}L`} /> */}
                            {
                                fetchedData?.fuel == "EV" ?
                                <VehicleOwnershipCostItem label={t("horsepower")} text={`${fetchedData?.electric_motor_horsepower > 0 ? fetchedData?.electric_motor_horsepower : '-'} PS`} />
                                :
                                <VehicleOwnershipCostItem label={t("horsepower")} text={`${fetchedData?.horsepower > 0 ? fetchedData?.horsepower : '-'} PS`} />
                            }
                            {/* <VehicleOwnershipCostItem label={t("horsepower")} text={`${fetchedData?.horsepower > 0 ? fetchedData?.horsepower : '-'}PS`} /> */}
                            <VehicleOwnershipCostItem label={t("transmission")} text={`${fetchedData?.transmission ?? '-'}`} />
                            {/* <VehicleOwnershipCostItem label={t("rated_economy")} text={fetchedData?.petrol_manufacturer_claim ?? '-'} /> */}
                        </div>
                    </div>
                    <VariantSeriesSale 
                        showHeader={true} 
                        t={t} data={vehicleOnSaleList} title={fetchedData?.name}
                        handleOnClickCompare={(value, type)=>_handleOnClickCompare(value, type, setCompareList)} 
                        isActiveVaraintList={_.compact(_.map(compareList, (value) => value.variant_id))} 
                        loading={loading}
                    />
                    <div className="vehicleVariant_placementBannerMargin">
                    </div>
                    <VehicleReviewAuthor title={fetchedData?.name} data={authorList} t={t} loading={loading} />
                    <div className="vehicleVariant_dealerMargin">
                        <DealerSection 
                            t={t} 
                            data={dealerList} 
                            brandName={fetchedData?.brand_name} 
                            brandCustomUrl={query?.vehicle[0]}
                            loading={loading} 
                            setPhoneNumberList={setPhoneNumberList}
                            setPhoneCallOpen={setPhoneCallOpen}
                        />
                    </div>
                    <div className="vehicleVariantPopularCarMargin">
                        <PopularCarBrands t={t} data={store?.path?.dataAllVehicleTopList?.brand} loading={store?.path?.dataAllVehicleTopList == undefined ? true : false} />
                    </div>
                </div>
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         <div className='bodyContainer'>
    //             <div ref={containerRef} className='vehicleVariantContainer contentContainer' style={(compareList.length >= 1 && width <= mobileViewWidth) ? {paddingBottom: `6.4rem`} : {}}>
    //                 <HeaderBack t={t} />
    //                 <VehicleModelVariant t={t} setVehicleVariantModalOpen={setVehicleVariantModalOpen} imagePath={!_.isEmpty(fetchedData?.variant_cover_image_path) ? fetchedData?.variant_cover_image_path : !_.isEmpty(fetchedData?.variant_image_path) ? fetchedData?.variant_image_path : ''} />
    //                 <div className="vehicleVariant_Box">
    //                     <div className="containerPadding">
    //                         <p className="fontSize_20 fontWeight_bold">
    //                             {fetchedData?.name}
    //                         </p>
    //                         <p className="fontSize_16 fontWeight_semiBold fontColor_lightBlue vehicleVariant_header_titlePrice">
    //                             {_numToPrice(fetchedData?.price)}
    //                         </p>
    //                         <p className="fontSize_12 fontColor_lightGrey3 vehicleVariant_header_titleMonlthPrice">
    //                             {`${_numToPrice(fetchedData?.monthly_payment)}/month`}
    //                         </p>
    //                     </div>
    //                     <VehicleOwnershipCost t={t} 
    //                         title={fetchedData?.name}
    //                         showHeader={false} 
    //                         showCompare={true}
    //                         data={{min_road_tax: fetchedData?.road_tax, min_insurance_cost: fetchedData?.insurance_cost, name: fetchedData?.name, price: fetchedData?.price, capacity: fetchedData?.capacity}}
    //                         selfVaranitData={fetchedData}
    //                         isActiveVaraintList={_.compact(_.map(compareList, (value) => value.variant_id))} 
    //                         handleOnClickCompare={(value, type)=>_handleOnClickCompare(value, type, setCompareList)} 
    //                     />
    //                     <div className="vehicleVariantSpec containerPadding">
    //                         <div className="vehicleVariantSpec_header">
    //                             <p className="fontSize_16 fontWeight_bold">
    //                                 {fetchedData?.name}
    //                             </p>
    //                             <Link href={`${pageLink.compare.compareMidUrl}${fetchedData?.compare_custom_url}?v1=${fetchedData?.variant_id}`}>
    //                                 <div className="vehicleVariantSpec_header_image cursorPointer">
    //                                     <img 
    //                                         className="w-100"
    //                                         src="/assets/images/right_circle_blue_icon.svg"
    //                                     />
    //                                 </div>
    //                             </Link>
    //                         </div>
    //                         <div className="vehicleVariantSpec_Contant">
    //                             <VehicleOwnershipCostItem label={t('body_type')} text={fetchedData?.body_type ?? '-'} />
    //                             <VehicleOwnershipCostItem label={t('segment')} text={fetchedData?.segment ?? '-'} />
    //                             {
    //                                 fetchedData?.fuel == "EV" ?
    //                                 <VehicleOwnershipCostItem label={t("ev_range")} text={`${fetchedData?.electric_motor_ev_range > 0 ? fetchedData?.electric_motor_ev_range : '-'} km`} />
    //                                 :
    //                                 <VehicleOwnershipCostItem label={t("capacity")} text={`${fetchedData?.capacity > 0 ? fetchedData?.capacity : '-'} L`} />
    //                             }
    //                             {/* <VehicleOwnershipCostItem label={t("capacity")} text={`${fetchedData?.capacity > 0 ? fetchedData?.capacity : '-'}L`} /> */}
    //                             {
    //                                 fetchedData?.fuel == "EV" ?
    //                                 <VehicleOwnershipCostItem label={t("horsepower")} text={`${fetchedData?.electric_motor_horsepower > 0 ? fetchedData?.electric_motor_horsepower : '-'} PS`} />
    //                                 :
    //                                 <VehicleOwnershipCostItem label={t("horsepower")} text={`${fetchedData?.horsepower > 0 ? fetchedData?.horsepower : '-'} PS`} />
    //                             }
    //                             {/* <VehicleOwnershipCostItem label={t("horsepower")} text={`${fetchedData?.horsepower > 0 ? fetchedData?.horsepower : '-'}PS`} /> */}
    //                             <VehicleOwnershipCostItem label={t("transmission")} text={`${fetchedData?.transmission ?? '-'}`} />
    //                             {/* <VehicleOwnershipCostItem label={t("rated_economy")} text={fetchedData?.petrol_manufacturer_claim ?? '-'} /> */}
    //                         </div>
    //                     </div>
    //                     <VariantSeriesSale 
    //                         showHeader={true} 
    //                         t={t} data={vehicleOnSaleList} title={fetchedData?.name}
    //                         handleOnClickCompare={(value, type)=>_handleOnClickCompare(value, type, setCompareList)} 
    //                         isActiveVaraintList={_.compact(_.map(compareList, (value) => value.variant_id))} 
    //                         loading={loading}
    //                     />
    //                     <div className="vehicleVariant_placementBannerMargin">
    //                     </div>
    //                     <VehicleReviewAuthor title={fetchedData?.name} data={authorList} t={t} loading={loading} />
    //                     <div className="vehicleVariant_dealerMargin">
    //                         <DealerSection 
    //                             t={t} 
    //                             data={dealerList} 
    //                             brandName={fetchedData?.brand_name} 
    //                             brandCustomUrl={query?.vehicle[0]}
    //                             loading={loading} 
    //                             setPhoneNumberList={setPhoneNumberList}
    //                             setPhoneCallOpen={setPhoneCallOpen}
    //                         />
    //                     </div>
    //                     <div className="vehicleVariantPopularCarMargin">
    //                         <PopularCarBrands t={t} data={store?.path?.dataAllVehicleTopList?.brand} loading={store?.path?.dataAllVehicleTopList == undefined ? true : false} />
    //                     </div>
    //                 </div>
    //                 <Footer t={t} />
    //             </div>
    //             {
    //                 compareList.length >= 1 &&
    //                 <CompareBottomButton compareList={compareList} t={t} handleOnClickGoCompare={(value)=>_handleOnClickGoCompare(value, router)} />
    //             }
    //             <VehicleVariantModal 
    //                 t={t}
    //                 vehicleVariantModalOpen={vehicleVariantModalOpen}
    //                 setVehicleVariantModalOpen={setVehicleVariantModalOpen}
    //                 handleClickVariantItem={_handleClickVariantItem}
    //                 vehicleVariantData={vehicleVariantData}
    //                 vehicleModelActive={{image_path: fetchedData?.model_image_path,brand_name: fetchedData?.brand_name, model_name: fetchedData?.model_name}}
    //                 isActiveVaraintList={[fetchedData?.variant_id]}
    //                 loading={loading}
    //             />
    //             <PhoneCallListModal
    //                 phoneCallOpen={phoneCallOpen}
    //                 setPhoneCallOpen={setPhoneCallOpen} 
    //                 phoneNumberList={phoneNumberList}
    //                 t={t}
    //             />
    //         </div>
    //     </>
    // )
}